import styled from "styled-components";

export const Wrapper = styled("footer")(({ theme }) => ({
  backgroundColor: theme.palette.headerBg, //transparent
  color: "#fff",
  flexShrink: 0,
}));
